module.exports = __webpack_public_path__ + "img/电21.154aeecb.png";